import React from "react"
import { Paper, FontIcon, IconButton } from "material-ui"
import UserForm from "./UserForm"
import UserProfilePicTile from "./UserProfilePicTile"
import I9UserProgress from "../../onboarding/I9UserProgress"
import UserI9Store from "../../../stores/UserI9Store"
import UserDetailChartSummary from "./UserDetailChartSummary"
import strings from "../../../localization/strings"
import _ from "lodash"
import autobind from "class-autobind"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { IUserDocument, ELoggedInUserType } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import SelfServiceLeaveDashboard from "./user-details-summary-for-self-service/SelfServiceLeaveDashboard"
import * as permissionHelper from "../../../helpers/permissionHelper"
import * as utils from "../../../helpers/utils"
import * as timeHelper from "../../../helpers/timeHelper"
import { grey50, grey500 } from "material-ui/styles/colors"
import AppStateStore from "../../../stores/AppStateStore"
import Sync from "material-ui/svg-icons/notification/system-update"
import * as api from "../../../api"
import * as userHelper from "../../../helpers/userHelper"

interface IProps {
	user: IUserDocument
	readonly: boolean
	userStatsTodayHours: number
	userStatsThisWeekHours: number
	loggedInUserType: ELoggedInUserType
	supervisorReadonlyForSelf: boolean
	onDeleteProfilePic(): void
	onUploadProfilePic(imageData): void
}
interface IState {
	i9: any
}

export default class UserDetailsSummary extends React.Component<IProps, IState> {
	fileUploader: HTMLInputElement

	constructor(props, context) {
		super(props, context)
		this.state = {
			i9: null,
		}
		autobind(this)
	}

	componentDidMount() {
		UserI9Store.on("change", this.changeEvent)
	}

	componentWillUnmount() {
		UserI9Store.removeListener("change", this.changeEvent)
	}

	changeEvent() {
		this.setState({ i9: UserI9Store.getI9() })
	}

	handleUpload() {
		this.fileUploader.click();
	}

	async handleFileChange(e) {
		if (!this.validateFileExtension(e.target.files[0])) {
			AppStateStore.setAlertDialogContent({
				title: strings.This_file_format_is_not_supported,
				content: strings.Supported_file_types + ": .png, .jpg, .jpeg"
			})
		} else if (!this.validateFileSize(e.target.files[0])) {
			AppStateStore.setAlertDialogContent({
				title: strings.This_file_size_is_too_large,
				content: strings.Maximum_File_Size + ": 10 MB"
			})
		} else {
			const imageData = await utils.getBase64(e.target.files[0]);
			this.props.onUploadProfilePic(`${imageData}`);
		}
	}

	validateFileExtension(_file) {
		const fileName = _file.name;
		const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

		return allowedExtensions.exec(fileName)
	}

	validateFileSize(_file) {
		const maxFileSize = 10 * 1024 * 1024; // 10 MB
		const fileSize = _file.size;

		return maxFileSize > fileSize;
	}

	render() {
		return (
			<Paper zDepth={1} style={{ display: "flex", minWidth: 1000, margin: 20, position: "relative", overFlow: "hidden" }}>
				<div style={{ flex: 5, alignItems: "center", textAlign: "center", padding: "0 8px", wordWrap: "break-word" }} >
					<div style={{ display: "flex" }}>
						<h2 style={{ textTransform: "uppercase", lineHeight: "30px", marginLeft: "auto", marginRight: "auto" }}>
							{this.props.user ? `${this.props.user.FirstName} ${this.props.user.LastName}` : ""}
						</h2>
						<FontIcon
							data-intercom-target={"menu-Employees-openEmployeeNotesAndAudit"}
							className="fa fa-info-circle"
							style={{ fontSize: 20, color: "#777777", margin: "18px 10px 0px 0px", cursor: "pointer" }}
							onTouchTap={() => AppStateStore.setNoteDrawerContent({
								drawerTitle: `${this.props.user.FirstName} ${this.props.user.LastName}`,
								objectData: {
									...this.props.user,
									ObjectId: this.props.user.Id
								},
								objectName: `${this.props.user.FirstName} ${this.props.user.LastName}`,
								dataType: "user",
							})}
						/>
					</div>
					<Paper
						zDepth={1}
						style={{ display: "inline-block", marginBottom: 20 }}
					>
						<UserProfilePicTile
							readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.EditProfilePic)}
							profileImageS3Url={this.props.user.ProfileImageS3Url}
							profileImage={this.props.user.ProfileImageID}
							onDelete={this.props.onDeleteProfilePic}
							onUpload={this.handleUpload}
						/>
					</Paper>
					<input type="file" id="file" onChange={this.handleFileChange} ref={(ref) => this.fileUploader = ref} style={{ display: "none" }} />
					{AccountStore.getHREnabled() &&
						<div style={{ fontSize: 16 }}>
							<span style={{ marginRight: 10 }}>{strings.HR_Profile}</span>
							<FontIcon
								className="fa fa fa-external-link"
								style={{ color: grey500, fontSize: 18, cursor: "pointer" }}
								onClick={(e) =>
									window.open(
										`${hr_url()}/people/${this.props.user.Id}`,
										e.ctrlKey ? "_blank" : "_self",
									)
								}
							/>
						</div>
					}
				</div >
				<div style={{ flex: 7, textAlign: "center", background: grey50, padding: 20, position: "relative" }}>
					{this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee &&
						<div style={{ display: "flex", alignItems: "center", marginTop: 0 }}>
							<div style={{ flex: 1 }}>
								<h1 className="user-detail-info-title">{timeHelper.convertToHour(this.props.userStatsTodayHours)}</h1>
								<h3 className="user-detail-info-subtext">{strings.Today_Hours}</h3>
							</div>
							<div style={{ flex: 1 }}>
								<h1 className="user-detail-info-title">{timeHelper.convertToHour(this.props.userStatsThisWeekHours)}</h1>
								<h3 className="user-detail-info-subtext">{strings.This_Week_Hours}</h3>
							</div>
						</div>
					}
					{this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee &&
						<IconButton
							data-intercom-target={"menu-Employees-Btn-Force-Mobile-Sync"}
							tooltip={strings.Force_Mobile_Sync}
							tooltipPosition="bottom-center"
							iconStyle={{ width: 30, height: 30 }}
							style={{ width: 60, height: 60, padding: 15, position: "absolute", right: 0, top: 0 }}
							onClick={() => userHelper.checkLoggedInUserPermission(this.props.user) &&
								AppStateStore.setConfirmDialogContent({
									content: strings.Are_you_sure_you_want_to_force_mobile_sync_this_employee,
									confirm: () => {
										AppStateStore.setProgressSnackbarContent("loading")
										api.forceMobileSync(this.props.user.Id).then(() =>
											AppStateStore.setProgressSnackbarContent(strings.Successfully_synced)
										)
									}
								})}
						>
							<Sync />
						</IconButton>
					}
					<div style={{ textAlign: "left", position: "relative", bottom: 0, marginTop: 0 }}>
						<UserForm
							readonly={this.props.readonly}
							user={this.props.user}
							loggedInUserType={this.props.loggedInUserType}
						/>
					</div>
				</div>
				<div
					className="WrapperUserDetailChartSummary"
					style={{ flex: 7, padding: "20px 0" }}
				>
					{true ?
						AccountStore.getAccrualsTimeoffEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.ViewUserAccrual) && permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking) ?
							<SelfServiceLeaveDashboard
								user={this.props.user}
								loggedInUserType={this.props.loggedInUserType}
								supervisorReadonlyForSelf={this.props.supervisorReadonlyForSelf}
							/> :
							<UserDetailChartSummary user={this.props.user} /> :
						<I9UserProgress />
					}
				</div>
			</Paper >
		)
	}
}
